import { LoyaltyRewardType } from '@onbeefapp/constants';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Stars from '../../../../../../packages/assets/images/stars.png';
import WallPaper from '../../../../../../packages/assets/images/wallpaper.png';
import Star from '../../../assets/images/star.png';
import HeaderBar from '../../../components/Headers/HeaderBar';
import { useRefreshLoyaltyData } from '../../../queries/loyalty';
import { useAuthStore } from '../../../stores/login';
import { useMerchantStore } from '../../../stores/merchant';
import { PointsLoyaltyDetail } from './PointsLoyaltyDetail';
import { StandardLoyaltyDetail } from './StandardLoyaltyDetail';

export const LoyaltyDetail: React.FC = () => {
  const merchantLoyaltyProgramme = useMerchantStore(
    (state) => state.loyalty_programme,
  );
  const user = useAuthStore((state) => state.user);
  const { mutateAsync: refreshLoyaltyData } = useRefreshLoyaltyData();
  const navigate = useNavigate();
  const updateLoyalty = useAuthStore((state) => state.updateLoyalty);

  const userLoyalty = user?.loyalty_programmes && user.loyalty_programmes[0];

  const handleRefreshLoyalty = async () => {
    const data = await refreshLoyaltyData();
    if (data) {
      updateLoyalty(data);
    }
  };

  useEffect(() => {
    handleRefreshLoyalty();
  }, []);

  const alreadySubed = userLoyalty != null;

  const isPoints =
    merchantLoyaltyProgramme?.reward.type === LoyaltyRewardType.POINTS;

  React.useEffect(() => {
    if (!merchantLoyaltyProgramme || !alreadySubed) {
      navigate('/loyalty', { replace: true });
    }
  }, [merchantLoyaltyProgramme, alreadySubed]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    alreadySubed && (
      <div className="w-full h-full">
        <div className="bg-primary z-[-9] absolute w-full h-60 opacity-50" />

        <img
          src={Stars}
          alt="Imagem do clube"
          className="w-full h-60 z-[-8] object-cover absolute top-0 grayscale"
        />
        <img
          src={WallPaper}
          alt="Imagem do clube"
          className="w-full h-60 z-[-10] object-cover absolute top-0 grayscale"
        />

        <div className="w-full h-full space-y-2">
          <HeaderBar className="p-4 !mb-16" colorButton="bg-white"></HeaderBar>
          <div className="flex flex-col space-y-4 items-center">
            <div className="absolute top-5 flex flex-col space-y-2">
              <img
                src={Star}
                alt="Imagem do clube"
                className="h-14 w-14 z-[-8] self-center"
              />
              <div className="text-lg font-medium text-contrastText">
                Clube de fidelidade
              </div>
            </div>
          </div>
        </div>

        {isPoints ? <PointsLoyaltyDetail /> : <StandardLoyaltyDetail />}
      </div>
    )
  );
};
